import { ref, watch } from 'vue'
import { useAccountSettingsStore } from '@/stores/accountSettings'
import { fetchIsePrimarySources } from '@/services/iseSettingsService'

export function usePublishedReadyCourtesySetting() {
  const accountSettings = useAccountSettingsStore()
  const separateReadyCourtesyVehicles = ref(false)
  const endpoint = String(import.meta.env.VITE_ISE_BACKEND_URL || '').replace(/\/+$/g, '')
  let requestSequence = 0

  const loadPublishedReadyCourtesySetting = async () => {
    const requestId = ++requestSequence
    const jazelId = String(accountSettings.accountId || '').trim()
    const token = String(accountSettings.sessionToken || '').trim()

    if (!endpoint || !jazelId) {
      separateReadyCourtesyVehicles.value = false
      return
    }

    try {
      const settings = await fetchIsePrimarySources(endpoint, jazelId, {
        includeDraft: false,
        token,
      })
      if (
        requestId !== requestSequence ||
        String(accountSettings.accountId || '').trim() !== jazelId
      ) {
        return
      }
      separateReadyCourtesyVehicles.value =
        settings.separate_ready_courtesy_vehicles === true
    } catch (error) {
      if (requestId !== requestSequence) return
      separateReadyCourtesyVehicles.value = false
      console.warn('Failed to load published Ready Courtesy setting:', error)
    }
  }

  watch(
    () => [accountSettings.accountId, accountSettings.sessionToken] as const,
    () => {
      void loadPublishedReadyCourtesySetting()
    },
    { immediate: true },
  )

  return {
    separateReadyCourtesyVehicles,
    loadPublishedReadyCourtesySetting,
  }
}
